import React, { CSSProperties } from 'react';
import {Row, Spin} from 'antd';

interface Props {
    style?: CSSProperties;
    className?: string;
}

export function LoadingScreen(props: Props) {
    return (
        <Row
            className={props.className}
            justify="center" align="middle"
            style={{height: '100%', margin: 'auto', ...props.style}}
        >
            <Spin size="large"/>
        </Row>
    );
}